import { Component } from '@angular/core';
import { membersuiteOrderLineItemEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Order Line Items') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteorderlineitem-form',
    templateUrl: './membersuiteorderlineitem.form.component.html'
})
export class membersuiteOrderLineItemFormComponent extends BaseFormComponent {
    public record!: membersuiteOrderLineItemEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

